import ErrorPage from 'components/UI/ErrorPage'
import { useI18n } from 'context/I18nProvider'

const css = '!w-[800px] h-[300px] m-64 ml-[22rem]'

function Page404({ noSideBar = false }) {
  const { i18n } = useI18n()

  return (
    <ErrorPage
      className={noSideBar ? css : ''}
      iconName="magnifying-glass"
      customError={{ statusText: i18n('page-not-found.text') }}
      title="404"
    />
  )
}

export default Page404
